// eslint-disable-next-line @typescript-eslint/no-var-requires
export const getAppVersion = () => require('../../package.json').version;
